import { style } from 'typestyle';
import { TEAL_PRIMARY } from '../../../theme';

const buildInputStyle = (valid: boolean | undefined) => {
  const validShadow = 'rgba(0, 168, 155, 0.25)';
  const invalidShadow = 'rgba(255, 0, 0, 0.25)';
  const shadowColor = valid ? validShadow : invalidShadow;

  return style({
    color: TEAL_PRIMARY,
    border: 'none',
    paddingLeft: 0,
    margin: '5px 3px',
    $nest: {
      '&:focus-visible': {
        boxShadow: `0 0 0 0.2rem ${shadowColor}`,
      },
    },
  });
};

const inputWrapper = style({
  position: 'relative',
  marginBottom: '8px',
  $nest: {
    '.form-control': {
      fontSize: '1rem',
      display: 'block',
      width: '100%',
      height: 'calc(1.5em + 0.75rem + 2px)',
      padding: '24px 12px 24px 0px',
      fontWeight: 400,
      lineHeight: 1.5,
      backgroundColor: '#fff',
      backgroundClip: 'padding-box',
      borderRadius: 0,
      transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
      paddingLeft: 0,
      fontFamily: '"Open Sans", sans-serif',
      $nest: {
        '&:focus': {
          color: ' #495057',
          backgroundColor: ' #fff',
          borderColor: '#29ffee',
          outline: 0,
          boxShadow: ' 0 0 0 .2rem #00a89b40',
        },
      },
    },
  },
});

const invalidWrapper = style({
  $nest: {
    '&::before': {
      color: '#ff0000',
      content: `"\\f12a"`, // exclamation point
      fontFamily: `"Font Awesome 5 Free"`,
      fontWeight: 900,
      position: 'absolute',
      top: '6px',
      left: '-7px',
    },
  },
});

export default {
  buildInputStyle,
  inputWrapper,
  invalidWrapper,
};
